var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M1.68 11.699a.936.936 0 0 0-1.394.007 1.121 1.121 0 0 0 .006 1.5l6.447 6.885L21.712 3.903a1.121 1.121 0 0 0 0-1.5.936.936 0 0 0-1.394 0L6.731 17.091z"}})}
var staticRenderFns = []

export { render, staticRenderFns }